import { render, staticRenderFns } from "./HubListAvatar.vue?vue&type=template&id=219f825f"
import script from "./HubListAvatar.vue?vue&type=script&lang=js"
export * from "./HubListAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports